import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './styles.css';

import { listingPropTypes } from '../../../../../utils/commonPropTypes';
import ListingResult from '../ListingResult';
import { setPosition } from '../../../../../utils/paginationHelper';

const EnginesList = (props) => {
    const {url, pos, tracking, labels } = props;
    return (
      <ol className={classnames('engines-list')}>
        {
          props.listings.map((listing, i) => {
            const position = setPosition(pos, i + 1);
            const listingArr = [
              <ListingResult
                key={listing.id}
                listing={listing}
                position={position}
                url={url}
                tracking={tracking}
                labels={labels}
              />
            ];

            return listingArr;
          }).reduce((prev, next) => [prev, ...next], [])
        }
      </ol>
    );
};

EnginesList.defaultProps = {
  showAds: false
};

EnginesList.propTypes = {
  labels: PropTypes.object.isRequired,
  listings: PropTypes.arrayOf(listingPropTypes).isRequired,
  pos: PropTypes.shape({
    page: PropTypes.string,
    pageSize: PropTypes.string,
  }).isRequired,
  tracking: PropTypes.object,
  url: PropTypes.string,
  showAds: PropTypes.bool
};

export default EnginesList;
